import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

const lightbox = new SimpleLightbox('.gallery a');

export function createGallery(images) {
  const gallery = document.querySelector('.gallery'); // ← перемещено сюда

  const markup = images
    .map(img => {
      return `
        <li class="gallery-item">
  <a href="${img.largeImageURL}">
    <img src="${img.webformatURL}" alt="${img.tags}">
  </a>
  <div class="info">
    <p><span class="label">Likes</span><span class="value">${img.likes}</span></p>
    <p><span class="label">Views</span><span class="value">${img.views}</span></p>
    <p><span class="label">Comments</span><span class="value">${img.comments}</span></p>
    <p><span class="label">Downloads</span><span class="value">${img.downloads}</span></p>
  </div>
</li>
`;
    })
    .join('');

  gallery.insertAdjacentHTML('beforeend', markup);
  lightbox.refresh();
}

export function clearGallery() {
  const gallery = document.querySelector('.gallery'); // ← и сюда
  gallery.innerHTML = '';
}

export function showLoader() {
  const loader = document.querySelector('.loader'); // ← и сюда
  loader.classList.remove('hidden');
}

export function hideLoader() {
  const loader = document.querySelector('.loader'); // ← и сюда
  loader.classList.add('hidden');
}
